<template>
  <div class="clienteleDetile">
    <div class="clienteleDetile-con">
      <div class="clienteleDetile-box">
        <div class="box-top clearfix">
          <div class="box-top-title cp">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
              <el-breadcrumb-item><a href="/clientele">客户案例</a></el-breadcrumb-item>
              <el-breadcrumb-item>{{detileData.title}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="box-con">
          <div class="con-title clearfix">
            <h1 class="con-title-name">{{detileData.title}}</h1>
            <div class="con-title-read">
              <span style="margin-right: 10px">{{detileData.view}}</span>
              <img src="../../assets/img/clientele/imgTwo.png" style="dispaly:inline-block;padding-bottom:3px" :alt="detileData.title" />
            </div>
          </div>
          <div class="con-describe">
            <div class="con-describe-span">{{detileData.xiangq_describe}}</div>
            <div class="con-describe-div clearfix">
              <div class="describe-div-img">
                <img style="width:174px;height:80px" :alt="detileData.title" v-lazy="$global.globalPath + detileData.xiangq_logo" />
              </div>
              <div class="describe-div-title">
                <div class="describe-title-top">公司名称</div>
                <div class="describe-title-botton">{{detileData.title}}</div>
              </div>
              <div class="describe-div-title">
                <div class="describe-title-top">应用产品</div>
                <div class="describe-title-botton">{{detileData.xiangq_product}}</div>
              </div>
              <div class="describe-div-title">
                <div class="describe-title-top">所属行业</div>
                <div class="describe-title-botton">{{detileData.industry_name}}</div>
              </div>
            </div>
          </div>
          <div class="con-detlie" v-html="detailContent"></div>
        </div>
        <div class="box-bottom">
          <div class="box-bottom-wire"></div>
          <div class="box-bottom-title">
            <span>了解甄云如何变革您的采购业务</span>
          </div>
          <div class="box-bottom-tel">
            <span>咨询热线：400-116-0808</span>
          </div>
          <div class="buttons">
            <el-button class="banner-button demo" @click="openDig(`clientele-detile-${$route.query.id}`)" round>方案详情</el-button>
            <el-button class="banner-button consult" round @click="goConsult">在线咨询</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'clienteleDetile',
  metaInfo () {
    return {
      title: this.detileData.xiangq_title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.detileData.industry_name
      },
      {
        name: 'description',
        content: this.detileData.xiangq_describe
      }]
    }
  },
  components: {
    hoverButton
  },
  data () {
    return {
      route: this.$route.name.toLowerCase(),
      detileData: this.$store.state.detailData || {},
      detailContent: this.$store.state.detailData.xiangq_content || ''
    }
  },
  created () {
    // 为了完成预渲染,请求接口的部分已经放到了 entry-server.js中
    // 但为了防止潜在风险，当store中无内容时会重新拉取接口
    if (!Object.keys(this.detileData).length) {
      this.getDetileData()
    } else {
    //  this.Islogin()
    }
  },
  methods: {
    openDig (code) {
      this.openRegister(false, code)
    },
    Islogin () {
      this.$api.post('/cases/twenty_four_hour', '', (r) => {
        if (r.code === 0) {
          if (r.data === 1) {
          } else {
            this.openRegister(false, `clientele-detile-${this.$route.query.id}`)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getDetileData () {
      let a = {
        case_id: this.$route.query.id
      }
      this.$api.post('/cases/case_detail', a, (r) => {
        if (r.code === 0) {
          this.detileData = r.data
          this.detailContent = r.data.xiangq_content
          //    this.Islogin()
        } else {
          this.$message.error(r.data)
          if (r.code === 7) {
            this.$router.push({
              path: '/404'
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" >
  @import "../../../static/css/clienteleDetile.scss";
</style>



// WEBPACK FOOTER //
// clienteleDetile.vue?47014fa0